module.exports = __webpack_public_path__ + "static/media/KCC_Member_Renewal_Form_2023.fbd3866f.docx";